'use strict';

export default [
  'ResourceService',
  class AuthService {
    constructor(resourceService) {
      this._resourceService = resourceService;
      this._API_BASE = '/auth';

      this.getCurrentUserPromise = null;
    }

    register(name, publicName, email, password, terms, refId, partnerId, recaptchaToken) {
      if (!name || !publicName || !email || !password || !terms) {
        return this._resourceService.errorPromise('auth:register: missing parameters');
      }

      let payload = {
        'full_name': name,
        'public_name': publicName,
        'email_address': email,
        'password': password,
        'accept_tos': terms,
        'ref_id': refId,
        'token': recaptchaToken,
      };

      if(partnerId) payload.partner = partnerId;

      return this._resourceService.post(`${this._API_BASE}/register`, payload).then((res) => {
        this._resourceService.storeOauthToken(res.token)
        return res;
      });
    }

    login(email, password, rememberMe, recaptchaToken) {
      if (!email || !password || rememberMe == null) {
        return this._resourceService.errorPromise('auth:login: missing parameters');
      }
      return this._resourceService.post(`${this._API_BASE}/login`, {
          'email_address': email,
          'password': password,
          'remember': rememberMe,
          'token': recaptchaToken,
        })
        .then((res) => {
          this._resourceService.storeOauthToken(res.token)
          return res;
        });
    }

    logout() {
      return this._resourceService.get(`${this._API_BASE}/logout`);
      this._resourceService.trashOauthToken();
    }

    verifyPublicName(publicName) {
      if (!publicName) {
        return this._resourceService.errorPromise('auth:verifyPublicName: missing parameters');
      }
      return this._resourceService.get(`${this._API_BASE}/validate-public-name?public_name=${publicName}`);
    }

    verifyEmailAddress(email) {
      if (!email) {
        return this._resourceService.errorPromise('auth:verifyEmailAddress: missing parameters');
      }
      return this._resourceService.get(`${this._API_BASE}/validate-email?email_address=${encodeURIComponent(email)}`);
    }

    resetPasswordRequest(email) {
      if (!email) {
        return this._resourceService.errorPromise('auth:resetPasswordRequest: missing parameters');
      }
      return this._resourceService.post(`${this._API_BASE}/reset-password-request`, {
        'email_address': email
      });
    }

    resetPassword(password, token) {
      if (!password || !token) {
        return this._resourceService.errorPromise('auth:resetPassword: missing parameters');
      }
      return this._resourceService.post(`${this._API_BASE}/reset-password`, {
        'password': password,
        'token': token
      });
    }

    quickRegister(orderNum, password, recaptchaToken) {
      if (!orderNum || !password) {
        return this._resourceService.errorPromise('auth:quickRegister: missing parameters');
      }
      return this._resourceService.post(`${this._API_BASE}/register/customer`, {
          'password': password,
          'orders': [orderNum],
          token: recaptchaToken,
        })
        .then((res) => {
          this._resourceService.storeOauthToken(res.token)
          return res;
        });
    }

    getCurrentUser() {
      if (!this.getCurrentUserPromise) {
        this.getCurrentUserPromise = this._resourceService.get(`${this._API_BASE}/current-user`);
      }

      this.getCurrentUserPromise
        .then((res) => this._resourceService.storeOauthToken(res.token))
        .finally(() => this.getCurrentUserPromise = null);

      return this.getCurrentUserPromise;
    }

    socialLogin(type, token, id, role) {
      if (!type || !token || !id || !role) {
        this._resourceService.errorPromise('auth:socialLogin: missing params');
      }

      return this._resourceService.post(`${this._API_BASE}/social/${type}`, {
        'provider_access_token': token,
        'provider_user_id': id,
        'user_role': role
      })
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/api-services/auth-service.js